import { WidgetTypeEnum } from "../../common/enum";
import WidgetBaseDetailModel from "./WidgetBaseDetailModel";
import WidgetLanguageDetailModel from "./WidgetLanguageDetailModel";
import AudioFileModel from "./AudioFileModel";

export default class LogRequestForHelpWidgetModel extends WidgetBaseDetailModel {
	public errorText: WidgetLanguageDetailModel[];
	public errorAudioFile: AudioFileModel[];
	public successText: WidgetLanguageDetailModel[];
	public successAudioFile: AudioFileModel[];
	public callbackURL: string;
	public isLogTimeoutsEnabled: boolean;
	public timeoutCallbackURL: string;

	constructor() {
		super();
		this.id = "LogRequestForHelp";
		this.type = WidgetTypeEnum.LogRequestForHelp;
		this.label = "Log Request For Help";
		this.errorText = [];
		this.errorAudioFile = [];
		this.successText = [];
		this.successAudioFile = [];
		this.callbackURL = "";
		this.isLogTimeoutsEnabled = false;
		this.timeoutCallbackURL = "";
	}
}
